"use strict";

const {history} = require('dibs-backbone');

const GalleryRouter = require('../GalleryRouter');

const GalleryStore = require('../stores/GalleryStore');
const GalleryModalStore = require('./GalleryModalStore');

const galleryActions = require('../actions/galleryActions');
const galleryModalActions = require('./galleryModalActions');

const GalleryModalRouter = GalleryRouter.extend({
    stores: [GalleryStore, GalleryModalStore],

    initialize() {
        this.route(history.getFragment(), () => this._hideModal());
        GalleryRouter.prototype.initialize.apply(this, arguments);
    },

    getPropsFromStores(galleryStore, galleryModalStore) {
        const props = {};

        // sets route to original url
        if (galleryModalStore.hasOpened() && galleryModalStore.isHidden()) {
            props.route = galleryModalStore.getOriginalUrl();

        // sets route to photo url
        } else if (!galleryModalStore.isHidden()) {
            props.route = galleryStore.getCurrentPhotoUrl();
        }
        return props;
    },

    /**
     * Route Handler - executes action to set photo
     *  (invoked mostly when the user hits the back button)
     */
    _setPhoto(urlLabel, rootId) {
        const galleryStore = this.context.getStore(GalleryStore);
        const url = galleryStore.buildPhotoUrl({urlLabel, rootId});

        if (url && typeof galleryStore.getPhotoByUrl(url) !== 'undefined') {

            // If Photo url exists, set url
            this.context.executeAction(galleryActions.setPhoto, {url});
            this.context.executeAction(galleryModalActions.showModal);
        } else {

            // Else refresh b/c navigating to photo URL outside of current gallery
            this.refresh();
        }
    },

    /**
     * Route Handler - executes action to hide the modal
     *  (invoked mostly when the user hits the back button from the modal)
     */
    _hideModal() {
        if (!this.context.getStore(GalleryModalStore).isHidden()) {
            this.context.executeAction(galleryModalActions.hideModal);
        }
    }
});

module.exports = GalleryModalRouter;



// WEBPACK FOOTER //
// ./assets/js/gallery/modal/GalleryModalRouter.es.js